import React, { createContext, useContext } from 'react';
const HarmonyThemeContext = /*#__PURE__*/createContext(false);
export const useIsHarmonyTheme = () => useContext(HarmonyThemeContext);
export const HarmonyThemeProvider = _ref => {
  let {
    enabled,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(HarmonyThemeContext.Provider, {
    value: enabled
  }, children);
};
//# sourceMappingURL=HarmonyTheme.js.map